import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When widget is selected or marked for editing, put it's variables to editing
 * state.
 */
export const syncWidgetVariablesForEditing = store.effects.create(
  (feature: ec.Collection<TypeParams>['feature'], widgetEc: Collection) =>
    widgetEc.plugins.currentEntityPlugin.feature.selectors
      .getLatestEntity()
      .asObservable.pipe(
        rxjs.map(widget =>
          widget
            ? widgetEc.editingVariablesFeature.actions.putInitialDefinitions
                .from('syncWidgetVariablesForEditing (effect)')
                .create(widget.variables ?? [])
            : widgetEc.editingVariablesFeature.actions.reset
                .from('syncWidgetVariablesForEditing (effect)')
                .create(),
        ),
      ),
)
